import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalComponent } from "@app/shared/components";
import { OperationType } from "@app/tool/model/operationType.model";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { PermissionService } from "@app/authentication/services/permission.service";

@Component({
    selector: 'app-operation-types-modal',
    templateUrl: './operation-types-modal.component.html',
    styleUrls: ['./operation-types-modal.component.scss']
})
export class OperationTypesModalComponent implements OnInit {

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Output('onCreate')
    onCreate: EventEmitter<any> = new EventEmitter();
    @Output('onUpdate')
    onUpdate: EventEmitter<any> = new EventEmitter();
    @Output('onDelete')
    onDelete: EventEmitter<any> = new EventEmitter();

    @Input() isLoading;

    public operationType: OperationType = new OperationType();

    operationTypeForm: UntypedFormGroup;

    previousOperationTypeName = '';

    showValidations = false;

    constructor(private permissionService: PermissionService) {
    }

    ngOnInit() {
        this.onFormInit();
    }

    open(editOperationType = new OperationType()) {
        this.operationType = Object.assign({}, editOperationType);
        this.previousOperationTypeName = editOperationType.name || '';
        this.showValidations = false;
        this.modal.open();
    }

    onFormInit() {
        this.operationTypeForm = new UntypedFormGroup({
            name: new UntypedFormControl(this.operationType.name, Validators.required),
            priority: new UntypedFormControl(this.operationType.priority, [Validators.required]),
        });
    }

    createOperationType() {
        if (this.operationTypeForm.invalid) {
            this.showValidations = true;
            return;
        }
        this.onCreate.emit(this.operationType);
        this.modal.close();
    }

    updateOperationType() {
        if (this.operationTypeForm.invalid) {
            this.showValidations = true;
            return;
        }
        this.onUpdate.emit({
            previousOperationTypeName: this.previousOperationTypeName,
            newOperationType: this.operationType
        });
        this.modal.close();
    }

    deleteOperationType() {
        this.onDelete.emit(this.operationType);
        this.modal.close();
    }

    get isEditMode() {
        return !!this.operationType.id;
    }

    shouldRenderModifiers() {
        return this.permissionService.hasHasPermissionForFeature('MANAGE_TOOLS');
    }
}
